import { styled } from "@mui/material/styles";
import type { CustomMessageActionsListProps } from "stream-chat-react";

// Stream's own classes keep the padding, hover and font of the built-in items.
const STREAM_ITEM_CLASS_NAME =
  "str-chat__message-actions-list-item str-chat__message-actions-list-item-button";

const CustomActionButton = styled("button")(({ theme }) => ({
  // Stream renders custom actions before its own. The list is a flex column, so a positive
  // order moves ours after every built-in item, which keep the default 0.
  order: 1,
  // Stream colours the item with a two-class rule scoped under the box
  // (`.str-chat__message-actions-box .str-chat__message-actions-list-item-button`), which ties
  // with a plain doubled selector and then wins on stylesheet order. Three classes outrank it.
  ".str-chat__message-actions-box &.str-chat__message-actions-list-item-button":
    {
      color: theme.palette.error.main,
    },
}));

/**
 * Replaces stream-chat-react's CustomMessageActionsList: same markup and handler contract, but the
 * items sit last in the menu and read as destructive. The only custom action is "Report" (ZS-1743),
 * a moderation step that should neither lead the list nor look like Reply or Pin.
 */
export const ChatMessageCustomActionsList = ({
  customMessageActions,
  message,
}: CustomMessageActionsListProps) => {
  if (!customMessageActions) {
    return null;
  }

  return (
    <>
      {Object.entries(customMessageActions).map(([label, handler]) => (
        <CustomActionButton
          key={label}
          type="button"
          role="option"
          aria-selected={false}
          className={STREAM_ITEM_CLASS_NAME}
          onClick={(event) => handler(message, event)}
        >
          {label}
        </CustomActionButton>
      ))}
    </>
  );
};
